// extracted by mini-css-extract-plugin
export default {"root":"g4Xafn7rlhxn2jRbYtav","header":"CCJ_UOaTwkbq4aPWdoQ3"};